import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------
const DEFAULT_ROWS_PER_PAGE = 50;
type MerchantListState = {
    selectedIncludeServices: string[];
    selectedExcludeServices: string[];
    rowsPerPage: number;
};

const initialState: MerchantListState = {
    selectedIncludeServices: [],
    selectedExcludeServices: [],
    rowsPerPage: DEFAULT_ROWS_PER_PAGE
};

const slice = createSlice({
    name: 'merchantList',
    initialState,
    reducers: {
        setSelectedIncludeServices(state, action: PayloadAction<string[]>) {
            state.selectedIncludeServices = action.payload;
        },
        setSelectedExcludeServices(state, action: PayloadAction<string[]>) {
            state.selectedExcludeServices = action.payload;
        },
        setRowsPerPage(state, action: PayloadAction<number>) {
            state.rowsPerPage = action.payload;
        },
        resetMerchantList(state) {
            state.selectedIncludeServices = [];
            state.selectedExcludeServices = [];
            state.rowsPerPage = 50;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { setSelectedIncludeServices, setSelectedExcludeServices, setRowsPerPage, resetMerchantList } = slice.actions;
